<!-- Enterprise Page Selector - Shows at top of enterprise-aware pages -->
<div class="enterprise-page-selector mb-3">
    <div class="d-flex align-items-center">
        <span class="me-2 text-muted small">
            <i class="fa-solid fa-building me-1"></i> Viewing:
        </span>
        
        <!-- Enterprise Manager View (locked to their enterprise) -->
        <div *ngIf="isEnterpriseManager && !canSwitchEnterprise" class="enterprise-badge">
            <span class="badge bg-warning text-dark">
                <i class="fa-solid fa-building me-1"></i>
                {{ enterpriseContext.currentEnterpriseDisplayName }}
            </span>
        </div>
        
        <!-- Admin View (dropdown to switch) -->
        <div *ngIf="canSwitchEnterprise" class="dropdown">
            <button
                class="btn btn-sm dropdown-toggle"
                [class.btn-outline-secondary]="isAllEnterprisesSelected"
                [class.btn-warning]="!isAllEnterprisesSelected"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <i class="fa-solid fa-building me-1"></i>
                {{ enterpriseContext.currentEnterpriseDisplayName }}
            </button>
            <ul class="dropdown-menu">
                <li>
                    <a 
                        class="dropdown-item" 
                        [class.active]="isAllEnterprisesSelected"
                        (click)="onEnterpriseSelect(null)"
                        href="javascript:void(0)"
                    >
                        <i class="fa-solid fa-globe me-2"></i> All Enterprises
                    </a>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li *ngFor="let enterprise of availableEnterprises">
                    <a 
                        class="dropdown-item" 
                        [class.active]="enterpriseContext.isEnterpriseSelected(enterprise.key)"
                        (click)="onEnterpriseSelect(enterprise.key)"
                        href="javascript:void(0)"
                    >
                        <i class="fa-solid fa-building me-2"></i> {{ enterprise.name }}
                    </a>
                </li>
            </ul>
        </div>
        
        <!-- Info text when filtered -->
        <span *ngIf="!isAllEnterprisesSelected" class="ms-2 text-muted small">
            (filtered)
        </span>
    </div>
</div>

